export const getCompanies = (state) => {
  return state.companies.companies || [];
};
